export default __webpack_public_path__ + "static/media/slider4.b79f9fc9.png";